import AbstractCRMApi from '../../AbstractCRMApi';

import { SelectOptions } from 'components/common/SelectInput';

class GlobalsApi extends AbstractCRMApi {
    protected endpoint = '';

    async getCountries(): Promise<SelectOptions> {
        return (await this.get('countries')).data;
    }

    async getStates(country: string): Promise<SelectOptions> {
        return (await this.get(`states/${country}`)).data;
    }
}

export default new GlobalsApi();
